<template>
    <div class="area-select-date">
        <div id="history_date_select">
            <Dropdown
                v-model="monthInput"
                class="dropdown-month"
                inputId="department"
                :addClass="theme"
                :inputLbl="monthLabel"
                :isFirstSave="false"
                :isShowErrorLbl="true"
                :itemList="listMonth"
                :errorInfo="errorInfo[0]"
                @changeEvent="changeEvent($event)"
            ></Dropdown>
            <Dropdown
                v-model="yearInput"
                class="dropdown-year"
                inputId="department"
                :addClass="theme"
                :inputLbl="yearLabel"
                :isFirstSave="false"
                :isShowErrorLbl="true"
                :itemList="listYear"
                :errorInfo="errorInfo[1]"
                @changeEvent="changeEvent($event)"
            ></Dropdown>
        </div>
    </div>
</template>
<script>
import Dropdown from "@/components/Input/Dropdown.vue";
export default {
    name: "HistoryDateSelect",
    computed: {
        theme: function () {
            return this.$store.state.theme;
        }
    },
    props: {
        lbl: Object,
        localeCode: Number,
        historyController: Object
    },
    components: {
        Dropdown
    },
    data: function() {
        return {
            errorInfo: [],
            listMonth: [],
            listYear: [],
            monthLabel: {
                name: "",
                placeholder: this.lbl.date.months,
                required: "",
                too_short: "",
                defaultText: this.lbl.date.months,
                invalid: ""
            },
            yearLabel: {
                name: "",
                placeholder:  this.lbl.date.years,
                required: "",
                too_short: "",
                defaultText:  this.lbl.date.years,
                invalid: ""
            },
            // v-model
            monthInput: null,
            yearInput: null,
        };
    },
    created: function() {
        this.errorInfo.push({ isValid: true, msg: "" }, { isValid: true, msg: "" });
        this.setMonthList();
        this.setYearList();
        // var allMonths = this.lbl.date.month_full;
        // var now = new Date();
        // var currentYear = now.getFullYear();
        // var currentMonth = now.getMonth();
        // this.listMonth.push({
        //     value: "all",
        //     text: "ทั้งหมด"
        // });
        // for (var i = currentYear; i > currentYear - 2; i--) {
        //     var monthInYear = allMonths;
        //     if (i == currentYear) {
        //         monthInYear = allMonths.filter(
        //             (v, index) => index <= currentMonth
        //         );
        //     }

        //     monthInYear = monthInYear.map((monthValue, monthIndex)  => {
        //         // var txt = `${monthValue} ${(this.localeCode != 1033) ? i + 543 : i}`;
        //         // var val = `${monthIndex + 1} ${i}`;

        //         var txt = `${monthValue}`;
        //         var val = `${monthIndex + 1}`;
        //         return {
        //             value: val,
        //             text: txt
        //         };
        //     });
        //     monthInYear = monthInYear.reverse();
        //     this.listMonth = [...this.listMonth, ...monthInYear];
        // }
        // this.errorInfo.push({ isValid: true, msg: "" }, { isValid: true, msg: "" });
    },
    methods: {
        setMonthList: function(){
            let months = this.lbl.date.month_full;
            for (let i in months) {
                let index = parseInt(i, 10) + 1 + '';
                this.listMonth.push({text: months[i], value: index >= 10 ? index : '0'+index,});
            }
            this.listMonth.push({ value: "all", text: this.lbl.date.months_all});
            this.listMonth.reverse();
        },
        setYearList: function(){
            let currentYear = parseInt(new Date().getFullYear(), 10);
            let yearText = currentYear;
            let localeCode = this.localeCode;
            if (localeCode == 1054) {
                yearText = yearText + 543;
            }

            this.listYear.push({ value: "all", text: this.lbl.date.years_all});
            for (let i=0 ; i<3 ; i++) {
                this.listYear.push({ value: currentYear-i + '', text: yearText-i + ''});
            }
        },
        changeEvent: function() {
            if (this.monthInput == 'all' && this.yearInput == 'all') {
                this.historyController.getAll();
            } else {
                if(this.monthInput && this.yearInput == 'all') return;
                if(this.monthInput && this.yearInput){
                    this.historyController.changeMonth(this.yearInput, this.monthInput);
                }
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
.area-select-date {
    padding: 20px 45px 20px 45px;

    #history_date_select{
        display: flex;
        width: 100%;
        margin: {
            left: auto;
            right: auto;
        }
        .dropdown-month{
            margin-right: 10px;
        }
        .dropdown-month .dropdown-year{
            width: calc(100% / 2);
        }
    }
}
</style>
